import { jsx as _jsx } from "react/jsx-runtime";
import { RouterProvider } from 'react-router-dom';
import router from '~/routes/AppRouter';
const App = () => _jsx(RouterProvider, { router: router });
export default App;
